import React, { useState } from 'react'
import { Modal } from 'react-bootstrap'
import AddMembersForm from './addMembersForm'
import { invite } from '../../../../services/vendorService'
import { toast } from 'react-toastify'
import constants from '../../../../config/constants'
import { friendlyMessageFor } from '../../../../utility/errorHelper'

type AddMembers = {
  show: boolean
  handleClose: () => void
}

function AddMembersModal({ show, handleClose }: AddMembers) {
  const [isSubmitting, setIsSubmitting] = useState(false)

  return (
    <>
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title data-testid="modal-title">Add Member</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <AddMembersForm
            isSubmitting={isSubmitting}
            inviteCallback={async (firstName, lastName, email, role) => {
              console.log('submitting...')
              setIsSubmitting(true)
              try {
                await invite(firstName, lastName, email, role)
                setIsSubmitting(false)
                toast.success(constants.alertMessage.memberInvited)
                handleClose()
              } catch (err) {
                console.error('Invite vendorUser error:', err)
                const message = friendlyMessageFor(err)
                toast.error(message, { autoClose: false })
                setIsSubmitting(false)
              }
            }}
          />
        </Modal.Body>
      </Modal>
    </>
  )
}

export default AddMembersModal
